import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '@pkg/assets/icons/v2/close.svg';
import { CircleButton, YatPill, YatTile } from '@pkg/components';

import { decimals } from '@app/helpers';

import './CartItem.scss';

export interface CartItemProps {
    yat: string;
    generation: number;
    price: number;
    rhythmScore: number;
    taken?: boolean;
    pending?: boolean;
    orderItemId: string;
    handleRemoveOrder: (orderItemId: string) => void;
    removedId: string;
}

const CartItem = ({
    yat,
    generation,
    price,
    rhythmScore,
    taken = false,
    pending = false,
    handleRemoveOrder,
    orderItemId,
    removedId,
}: CartItemProps) => {
    const { t } = useTranslation(['yat_picker', 'words']);

    const classNames = useMemo(() => {
        const classNames: string[] = ['yat-cart-item'];
        if (taken || pending) classNames.push('yat-cart-item--muted');
        if (removedId === orderItemId) classNames.push('yat-cart-item--removed');
        return classNames.join(' ');
    }, [taken, pending, removedId, orderItemId]);

    const removedItem = (orderItemId) => {
        handleRemoveOrder(orderItemId);
    };

    return (
        <li className={classNames}>
            <YatTile yat={yat} generation={generation} rhythmScore={rhythmScore} classes="yat-cart-item__yat-tile" />
            <div className="yat-cart-item__meta">
                <div className="yat-cart-item__pill">
                    {taken && (
                        <YatPill variant="danger" size="small">
                            {t('words:taken')}
                        </YatPill>
                    )}
                    {!taken && pending && (
                        <YatPill size="small" variant="warning">
                            {t('words:pending')}
                        </YatPill>
                    )}
                    {!taken && !pending && <YatPill size="small">${decimals(price)}</YatPill>}
                </div>
                <div className="yat-cart-item__actions">
                    <div className="yat-cart-item__button">
                        <CircleButton
                            size="small"
                            ariaLabel={t('remove_yat_from_cart', { yat: yat })}
                            onClick={() => removedItem(orderItemId)}
                        >
                            <CloseIcon />
                        </CircleButton>
                    </div>

                    {/*hiding until we have the functionality*/}
                    {/*<div className="yat-cart-item__button">*/}
                    {/*    <CircleButton size="small" ariaLabel={t('edit_yat', { yat: yat })}>*/}
                    {/*        <EditIcon className="" />*/}
                    {/*    </CircleButton>*/}
                    {/*</div>*/}
                </div>
            </div>
        </li>
    );
};

export default CartItem;
